import { normalizeColor } from "../util/";

interface OptionsRpr {
    /** Bold */
    bold?: boolean;
    /** Color: HEX value */
    color?: string;
    /** Font family */
    font?: string;
    /** Font size: point values */
    fontSize?: number;
    /** Highligh color */
    highlight?:
        | "black"
        | "blue"
        | "cyan"
        | "green"
        | "magenta"
        | "red"
        | "yellow"
        | "white"
        | "darkBlue"
        | "darkCyan"
        | "darkGreen"
        | "darkMagenta"
        | "darkRed"
        | "darkYellow"
        | "darkGray"
        | "lightGray"
        | "none";
    /** Italic */
    italic?: boolean;
    /** Language */
    lang?: string;
    /** Character style */
    rStyle?: string;
    /** Strikethrough */
    strikethrough?: boolean;
    /** Underline */
    underline?:
        | "single"
        | "words"
        | "double"
        | "thic"
        | "dotted"
        | "dottedHeavy"
        | "dash"
        | "dashedHeavy"
        | "dashLong"
        | "dashLongHeavy"
        | "dotDash"
        | "dashDotHeavy"
        | "dotDotDash"
        | "dashDotDotHeavy"
        | "wave"
        | "wavyHeavy"
        | "wavyDouble"
        | "none";
}

/**
 * Create rPr this.options
 */
class CreateRpr {
    /**
     * Element options
     */
    protected options: OptionsRpr;

    /**
     * Constructor
     *
     * @param options - Options rPr
     */
    constructor(options: OptionsRpr) {
        this.options = options;
    }

    /**
     * Creates content
     *
     * @returns Contents
     */
    public create(): string {
        const contents = this.createRpr();

        return contents;
    }

    /**
     * Create rPr Styles
     *
     * @returns string
     */
    protected createRpr(): string {
        let contents = "<w:rPr>";

        if (this.options.bold != null) {
            contents += '<w:b w:val="' + this.options.bold + '" />';
            contents += '<w:bCs w:val="' + this.options.bold + '" />';
        }

        if (this.options.color != null) {
            contents +=
                '<w:color w:val="' +
                normalizeColor(this.options.color) +
                '" />';
        }

        if (this.options.font != null) {
            contents +=
                '<w:rFonts w:ascii="' +
                this.options.font +
                '" w:cs="' +
                this.options.font +
                '" w:hAnsi="' +
                this.options.font +
                '"/>';
        }

        if (this.options.fontSize != null) {
            contents += '<w:sz w:val="' + this.options.fontSize * 2 + '" />';
            contents += '<w:szCs w:val="' + this.options.fontSize * 2 + '" />';
        }

        if (this.options.highlight != null) {
            contents +=
                '<w:highlight w:val="' + this.options.highlight + '" />';
        }

        if (this.options.italic != null) {
            contents += '<w:i w:val="' + this.options.italic + '" />';
        }

        if (this.options.lang != null) {
            contents += '<w:lang w:val="' + this.options.lang + '" />';
        }

        if (this.options.rStyle != null) {
            contents += '<w:rStyle w:val="' + this.options.rStyle + '" />';
        }

        if (this.options.strikethrough != null) {
            contents +=
                '<w:strike w:val="' + this.options.strikethrough + '"/>';
        }

        if (this.options.underline != null) {
            contents += '<w:u w:val="' + this.options.underline + '"/>';
        }

        contents += "</w:rPr>";

        return contents;
    }
}

export { CreateRpr, OptionsRpr };
